import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Transaction_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_TXN_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Txn WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    TXN_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Txn Id', columnResourceName: 'colTxnId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    TXN_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}}
}

var TransactionSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_TXN_ID',
        id_ui: 'TXN_ID',
        name:  'TXN_NAME'},


    searchProviderFields: vUI_Transaction_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Transaction_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var TransactionSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "TransactionSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'TXN_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'TXN_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'TXN_ID','TXN_NAME','SOURCE_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: TransactionSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var TransactionSearch: ISearch = {
    searchName: "Find Transaction",
    renderOptions: { ui5ResourceId: "TransactionSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [TransactionSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("TransactionBO", "Transaction", TransactionSearch, "Transaction Search")

export {TransactionSearch}